import React from 'react';
import PropTypes from 'prop-types';
import AssessmentButton from '../../../common/components/buttons/assessment.jsx';

const styles = {
	leftButton : {
		marginRight : 10,
	},
	message : {
		textAlign : 'center',
		marginBottom : 3,
	}
};

class GameVenueControls extends React.Component {
	constructor(props) {
		super(props);

		this.yesClicked = this.yesClicked.bind(this);
		this.noClicked = this.noClicked.bind(this);
	}

	showManagement() {
		this.props.showGameVenueManagementPopup(this.props.gameId);
	}

	yesClicked () {
		const newVal = (this.props.assessment === 'confirm') ? 'unsure' : 'confirm';

		this.props.addGameVenueAssessment({
			assessmentValue : newVal,
			gameId : this.props.gameId,
			venueId : this.props.venueId
		});
	}

	noClicked () {
		const newVal = (this.props.assessment === 'flag') ? 'unsure' : 'flag';

		this.props.addGameVenueAssessment({
			assessmentValue : newVal,
			gameId : this.props.gameId,
			venueId : this.props.venueId
		}, () => {
			if (newVal === 'flag') {
				this.showManagement();
			}
		});
	}

	render() {
		return (
			<div>
				<div style={styles.message}>Is this venue correct?</div>
				<AssessmentButton
					text="Yes"
					sentiment="positive"
					onClick={this.yesClicked}
					isActive={(this.props.assessment === 'confirm')}
					style={styles.leftButton}
				/>
				<AssessmentButton
					text="No"
					sentiment="negative"
					onClick={this.noClicked}
					isActive={(this.props.assessment === 'flag')}
				/>
			</div>
		);
	}
}

GameVenueControls.propTypes = {
	showGameVenueManagementPopup: PropTypes.func,
	addGameVenueAssessment: PropTypes.func,
	assessment: PropTypes.string,
	venueId: PropTypes.number,
	gameId: PropTypes.number,
};


export default GameVenueControls;